/* CleverTap "Add to Cart IL" tracking for product-card add-to-cart buttons.
   Moved verbatim out of snippets/addtocart_btn.liquid, where the same
   ~2.9KB inline <script> (getPageType/getPageTitle/getUTMParams + the
   DOMContentLoaded binder) was emitted once PER PRODUCT CARD: 9x on home,
   30-45x on collection pages. One deferred, cached file instead. Behaviour is
   unchanged: the binder still runs on DOMContentLoaded (+1.5s), binds every
   .add-to-cart button once, and pushes the same payload. */
(function () {
  if (window.__wbnAtcTrackingInit) return;
  window.__wbnAtcTrackingInit = true;

  function getPageType() {
    var firstPath = window.location.pathname.split('/')[1];
    return firstPath === 'products' ? 'Product' : 'Other';
  }
  function getPageTitle() { return document.title; }
  function getUTMParams() {
    var urlParams = new URLSearchParams(window.location.search);
    return {
      campaign: urlParams.get('utm_campaign') || '',
      content: urlParams.get('content') || '',
      medium: urlParams.get('utm_medium') || '',
      source: urlParams.get('utm_source') || '',
      term: urlParams.get('term') || ''
    };
  }
  // Legacy globals: other inline code in the theme may still call these.
  window.getPageType = window.getPageType || getPageType;
  window.getPageTitle = window.getPageTitle || getPageTitle;
  window.getUTMParams = window.getUTMParams || getUTMParams;

  function readLocation() {
    try { return JSON.parse(localStorage.getItem('_locIL')); } catch (e) { return null; }
  }

  function bindCardButtons() {
    var addToCartBtn = document.querySelectorAll('.add-to-cart');
    var locationData = readLocation();
    setTimeout(function () {
      addToCartBtn.forEach(function (button) {
        if (button.dataset.listenerAttached) return;
        button.addEventListener('click', function () {
          var productData = {};
          try { productData = JSON.parse(this.getAttribute('data-product')) || {}; } catch (e) {}
          var isWishListPage = window.location.pathname.includes('/pages/wishlist');
          var utm = getUTMParams();
          var clevertapPayload = {
            'Product ID': productData.id,
            'Product Name': productData.title,
            'Product Price': productData.variant_price / 100,
            'Product Handle': productData.handle,
            'Variant ID': productData.variant_id,
            'Product Image': productData.image,
            'City': locationData && locationData.city,
            'Currency': 'INR',
            'Country': locationData && locationData.country_code,
            'Page URL': window.location.href,
            'Page Title': getPageTitle(),
            'Page Type': getPageType(),
            'Product Compare At Price': productData.variant_compare_at_price / 100,
            'Quantity': 1,
            'Variant Title': productData.variant_title,
            'Vendor Name': productData.vendor,
            'Product Type': productData.product_type,
            'Platform': 'Web',
            'UTM Campaign': utm.campaign,
            'UTM Content': utm.content,
            'UTM Medium': utm.medium,
            'UTM Source': utm.source,
            'UTM Term': utm.term,
            'isWishListPage': isWishListPage
          };
          if (window.clevertap && clevertap.event && clevertap.event.push) {
            clevertap.event.push('Add to Cart IL', clevertapPayload);
          }
        });
        button.dataset.listenerAttached = 'true';
      });
    }, 1500);
  }

  // PDP main button (#add-to-cart-btn-IL): payload comes from data-* attributes
  // rendered by snippets/product-form.liquid (was Liquid interpolated into the
  // inline script; identical values).
  function bindPdpButton() {
    var btn = document.getElementById('add-to-cart-btn-IL');
    if (!btn || btn.dataset.wbnCtBound) return;
    btn.dataset.wbnCtBound = 'true';
    var locationData = readLocation();
    btn.addEventListener('click', function () {
      var d = btn.dataset;
      var quantity = document.querySelector('.js-qty__num[name="quantity"]');
      var utm = getUTMParams();
      var clevertapPayload = {
        'Product ID': d.ctProductId || '',
        'Product Name': d.ctProductTitle || '',
        'Product Price': d.ctPrice || '',
        'Product Handle': d.ctHandle || '',
        'Product Image': d.ctImage || '',
        'City': locationData && locationData.city,
        'Currency': 'INR',
        'Country': locationData && locationData.country_code,
        'Page URL': window.location.href,
        'Page Title': document.title,
        'Page Type': getPageType(),
        'Product Compare At Price': d.ctCompareAtPrice || '',
        'Quantity': quantity ? quantity.value : undefined,
        'Variant ID': d.ctVariantId || '',
        'Variant Title': d.ctVariantTitle || '',
        'Vendor Name': d.ctVendor || '',
        'Product Type': d.ctProductType || '',
        'Platform': 'Web',
        'UTM Campaign': utm.campaign,
        'UTM Content': utm.content,
        'UTM Medium': utm.medium,
        'UTM Source': utm.source,
        'UTM Term': utm.term,
        'isWishListPage': window.location.pathname.includes('/pages/wishlist')
      };
      if (window.clevertap && clevertap.event && clevertap.event.push) {
        clevertap.event.push('Add to Cart IL', clevertapPayload);
      }
    });
  }

  function init() { bindCardButtons(); bindPdpButton(); }
  // Re-bind hooks for grids inserted after DOMContentLoaded (collection-tabs
  // lazy tabs). bindCardButtons is idempotent via dataset.listenerAttached.
  window.__wbnBindAtcButtons = bindCardButtons;
  document.addEventListener('wbn:grid:injected', function () { bindCardButtons(); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
